import React from 'react';
import PropTypes from "prop-types";

import {Button} from 'reactstrap';

import Framework from "@beardeddevops/react.framework";

import {Objects} from "components";
import UniversalModalOverride from "components/UniversalModalOverride";


export default class TransactionEvent extends React.Component {
	static propTypes = {
		object: PropTypes.object.isRequired,
		properties: PropTypes.object.isRequired,
		locations: PropTypes.array.isRequired,
		history: PropTypes.object.isRequired,
		onSelectUpdate: PropTypes.func.isRequired,
		shouldLoad: PropTypes.bool.isRequired,
		afterEventSave: PropTypes.func.isRequired,
		isNew: PropTypes.bool
	};

	constructor(props, context) {
		super(props, context);
		this.state = {
			id: null,
			binary_id: null,
			object: null,
			eventModalOpen: false,
		};
	}

	handleToggleEventModal = () => {
		this.setState({eventModalOpen: !this.state.eventModalOpen});
	}

	handleAddEventClick = () => {
		this.setState({
			id: null,
			binary_id: null,
			object: null
		});

		this.handleToggleEventModal();
	}

	handleEventEditClick = () => {
		/** @type {Transactions_Collections_Object} object */
		let object = this.props.object;

		this.setState({
			id: object.event,
			binary_id: object.event_binary_id,
			object: object.events
		});

		this.handleToggleEventModal();
	}

	render() {

		/** @type {Transactions_Collections_Object} object */
		let object = this.props.object;
		let {properties, afterEventSave, onSelectUpdate, shouldLoad} = this.props;

		return <div>
			<div className={'form-group'}>
				<div className="row">
					<div className="col-4">
						<span className="input-label">Event</span>

						<UniversalModalOverride
							locations={this.props.locations}
							states={this.props.states}
							history={this.props.history}
							id={this.state.id}
							binary_id={this.state.binary_id}
							name={"Event"}
							object={Objects.Event}
							objectProps={{
								object: this.state.object
							}}
							showModal={this.state.eventModalOpen}
							handleToggle={this.handleToggleEventModal}
							afterSave={afterEventSave}
						/>
					</div>
					<div className="col-8 d-flex">
						<Button
							onClick={this.handleAddEventClick}
							data-id={'add-event'}
							className={"select-add"}
							size={"sm"} outline color="primary"
						>
							<i className="fa fa-plus"/>
						</Button>
						{object.event ?
							<Button
								onClick={this.handleEventEditClick}
								data-id={'edit-event'}
								className={"select-add"}
								size={"sm"}
								outline color="green-meadow"
							>
								<i className="fa fa-pencil"/>
							</Button>
							: null}
						<div className="flex-grow-1">
							<Framework.Elements.Select
								shouldLoad={shouldLoad}
								property={properties.event}
								value={object.event}
								binary_id={object.event_binary_id}
								error={object.event_error}
								object={object.events}
								update={onSelectUpdate}
								nullable={true}
								requestOverride={this.props.isNew ? 'GET_EVENTS_CURRENT' : 'GET_ALL'}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>

	}
}

